
import { Component, computed, inject, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { CableListComponent } from './cable-list/cable-list.component';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { MceApiService } from '../core/mceapi.client.generated';


@Component({
  selector: 'cables',
  imports: [PageWithNavigationComponent, CableListComponent, MatIconModule, MatProgressBarModule, MatProgressSpinnerModule, MatMenuModule, MatButtonModule],
  templateUrl: './cables.component.html',
})

export class CablesComponent {

  private readonly cableList = viewChild(CableListComponent);
  readonly hasUnsavedChanges = computed(() => this.cableList()?.hasUnsavedChanges() ?? false);
  readonly isSaving = computed(() => this.cableList()?.processing() ?? false);

  private route = inject(ActivatedRoute);
  private mceApiService = inject(MceApiService);
  private projectUid = toSignal(
    this.route.paramMap.pipe(map(params => params.get('projectUid'))),
    { initialValue: this.route.snapshot.paramMap.get('projectUid') }
  );

  projectResource = rxResource({
    params: () => this.projectUid() ?? undefined,
    stream: ({ params: projectUid }) => this.mceApiService.v1ProjectsGet(projectUid)
  });
  project = computed(() => this.projectResource.value());

  viewState = computed(() => {
    return {
      projectReady: this.project()?.uid !== undefined,
    }
  })


}


